export default {
  token: 'token=',
  expiryDate: 'expiryDate=',
  last4cc: 'last4=',
};
